import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public readonly isMandantNameUpdated = new BehaviorSubject<string>('');

  private readonly disableSubject = new Subject<boolean>();
  private history = 0;

  constructor(private readonly router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.history++;
      }
    });
  }

  onMandantNameUpdated(firmenOderNachname: string, vorname: string): void {
    let updated = firmenOderNachname;
    if (!!vorname && vorname !== '') {
      if (!firmenOderNachname || firmenOderNachname === '') {
        updated = vorname;
      } else {
        updated = `${firmenOderNachname}, ${vorname}`;
      }
    }
    if (!updated || updated === '') {
      updated = 'Mandantenname nicht bekannt';
    }
    this.isMandantNameUpdated.next(updated);
  }

  changeDisableStatus(disable: boolean): void {
    this.disableSubject.next(disable);
  }

  getDisableStatus(): Observable<boolean> {
    return this.disableSubject.asObservable();
  }
}
